export const formNeighborhood = [
  {
    name: 'neighborhood',
    label: 'Bairro',
    grid: { xs: 12 },
  },
];
